import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import { CardTypes } from '../../utils/enums';
import { getActionCompletedTime } from '../../utils/actionTiming';

import { onAnswerClick } from './actions.js';

import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';

import { onGoToNextCard, onShowEmailInterstitial } from '../Widget/actions';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import AnswerButton from '../../components/Assessment/AnswerButton';
import CssTransition from '../../components/Transition/CssTransition';
import EmailInterstitial from '../../components/EmailInterstitial/EmailInterstitialPopup';

import {
    SingleAction,
    parseSingleActionProps,
    requiredFunctionsForSingleAction
} from '../SingleAction/SingleActionDetails';

class PollStart extends SingleAction {
    buttonComponent() {
        return (
            <AutoScalingButtonSet>
                {this.props.answers.map(a => (
                    <AnswerButton
                        key={a.id}
                        text={a.text}
                        textUppercase={this.props.makeUppercase}
                        useLoadingSpinner={true}
                        onClick={() => {
                            const nextAction = getNextAction(
                                this.props.allWidgetActions,
                                this.props.activeAction.identifier,
                                [
                                    {
                                        actionIdentifier: this.props.activeAction
                                            .identifier,
                                        answerId: a.id
                                    }
                                ],
                                this.props.cards
                            );
                            if (this.props.skipEndCard) {
                                this.props.handleSkippingEndCard(
                                    nextAction,
                                    this.props.cards,
                                    this.props.onGoToNextCard
                                );
                            }

                            this.props.onAnswerClick(
                                this.props.apiRequestData,
                                a.id,
                                a.text,
                                this.props.activeAction.identifier,
                                this.props.actionCompletedTime(),
                                this.props.isMultiActionsCard,
                                this.props.skipEndCard && !!nextAction,
                                this.props.cardTitle,
                                this.props.isLastActionInWidget,
                                this.props.showEmailInterstitial,
                                this.props.onShowEmailInterstitial,
                                this.props.answers,
                                this.props.noOfAnswers,
                                this.props.widgetId,
                                this.props.actionInitiated
                            );
                        }}
                    />
                ))}
            </AutoScalingButtonSet>
        );
    }
    overlayComponents() {
        return (
            <TransitionGroup>
                {this.props.emailInterstitialVisibility && (
                    <CssTransition key="alert" in={this.props.onShowEmailInterstitial}>
                        <EmailInterstitial />
                    </CssTransition>
                )}
            </TransitionGroup>
        );
    }
}
PollStart.propTypes = {
    ...SingleAction.propTypes,
    allWidgetActions: PropTypes.array.isRequired,
    widgetId: PropTypes.string.isRequired,
    cardTitle: PropTypes.string.isRequired,
    answers: PropTypes.array.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    isLastActionInWidget: PropTypes.bool.isRequired,
    cards: PropTypes.array.isRequired,
    skipEndCard: PropTypes.bool,
    nextAction: PropTypes.object,
    activeAction: PropTypes.object,
    makeUppercase: PropTypes.bool.isRequired,
    longText: PropTypes.bool.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    onShowEmailInterstitial: PropTypes.func.isRequired,
    showEmailInterstitial: PropTypes.bool.isRequired,
    emailInterstitialVisibility: PropTypes.bool.isRequired
};

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            ...parseSingleActionProps(state),
            allWidgetActions: state.widget.actions,
            widgetId: state.widget.widgetRequestId,
            answers:
                state.widget.activeAction.possibleAnswers !== undefined
                    ? state.widget.activeAction.possibleAnswers
                          .filter(a => a.isOpen === false)
                          .slice(0, 4)
                    : [],
            apiRequestData: state.widget.apiRequestData,
            actionCompletedTime: getActionCompletedTime(state, 'poll'),
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isLastActionInWidget:
                state.widget.cards.length === state.widget.activeAction.order,
            cards: state.widget.cards,
            skipEndCard: state.widget.activeAction.skipEndCard,
            nextAction,
            activeAction: state.widget.activeAction,
            makeUppercase: (state.widget.activeAction.possibleAnswers || []).every(
                a => !a.isOpen && a.text.length <= 8
            ),
            longText: (state.widget.activeAction.possibleAnswers || []).some(
                a => !a.isOpen && a.text.length >= 20
            ),
            actionInitiated: state.poll.actionInitiated,
            showEmailInterstitial: state.widget.activeAction.collectEmail > 0,
            emailInterstitialVisibility: state.widget.showEmailInterstitial || false,
            cardTitle: state.widget.activeAction.name,
            cardDescription: state.widget.activeAction.description || ''
        };
    },
    {
        ...requiredFunctionsForSingleAction,
        onAnswerClick,
        onGoToNextCard,
        onShowEmailInterstitial,
        handleSkippingEndCard
    }
)(PollStart);



// WEBPACK FOOTER //
// ./src/containers/Poll/PollDetails.jsx